// This icon file is generated automatically.
var GoodOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M127.23 496.2l224.51 178.87 559.04-515s37.5-34.25 70.28-7.5c9.72 8 20.99 30.79-4.36 66.5L393.02 902.78s-44.73 61.25-97.85-.64l-251.9-340.1s-29.9-46.07 7.48-73.66c12.67-9.21 41.35-23.68 76.48 7.81z" } }] }, "name": "good", "theme": "outlined" };
export default GoodOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/GoodOutlined.js
// module id = 2893
// module chunks = 0